
import { Printer,PrintOptions } from '@ionic-native/printer';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the AlacakliCariHesaplarReportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-alacakli-cari-hesaplar-report',
  templateUrl: 'alacakli-cari-hesaplar-report.html',
})
export class AlacakliCariHesaplarReportPage {
  AlacakliListesi = [];
  AlacakliListesi2 = [];
  aranan = "";
  toplamalacak: number = 0;
  take: number = 5000;
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,

    private printer: Printer,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.cariAra(null);

  }
  cariAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);

    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "AlacakliCariHesaplar", "", false).then(a => {

      var sonuc = <any>a;
      this.AlacakliListesi = sonuc.SonucObject;
      this.AlacakliListesi.forEach(element => {
        element.Bakiyesi = element.Bakiyesi * -1;
        this.toplamalacak += element.Bakiyesi;
        console.log("toplam alacak", this.toplamalacak);

      });
      this.AlacakliListesi2 = this.AlacakliListesi.filter(a => a.Bakiyesi != 0);
      console.log("sonlistes", this.AlacakliListesi2);


    })
  }
  cariler(e) {

    if (e.keyCode == 13) {
      this.cariAra(e);
    }
  }


  yazdirma() {
    var html = "<html><head>  <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css' rel='stylesheet'></head><body>" +
      "<table style='width: 100%;border-bottom:1px solid lightgray;margin-bottom:30px'>" +
      "<tbody>" +
      "<tr>" +
      "<td style'width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'>  ISPARTA</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;<span style='color: #cc0000;'><strong style='font-size: 30px;'>NETLIFE YAZILIM </strong></span></td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> 05359837610</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> www.netlifeyazilim.com-info@netlifeyazilim.com</span></td>" +
      "</tr>" +
      "</tbody>" +
      "</table>" +
      "<div style='float:left;width:100%'>Cari Hesap Kodu:<strong>" + "cariBilgi.CODE" + "</strong></div>" +
      "<div style='float:left;width:100%;margin:bottom:20px'>Cari Hesap Unvanı:<strong>" + "cariBilgi.DEFINITION_" + "</strong></div>" +
      "<div class='card text-center'>" +

      "<div class='card-footer text-muted'>" +
      "Sipariş / Teklif detayları " +
      "</div>" +
      "</div><hr/>" +
      "<table class='table table-striped table-bordered table-hover'>" +
      "<thead>" +
      "<tr>" +
      "<th>Açıklama</th>" +
      "<th>Miktar</th>" +
      "<th>Birim</th>" +
      "<th>Fiyat</th>" +
      "<th>İsk. 1</th>" +
      "<th>İsk. 2</th>" +
      "<th>KDV</th>" +
      "<th>Tutar</th>" +
      "</tr>" +
      "</thead>" +
      "<tbody>";
    this.AlacakliListesi2.forEach(extre => {
      html = html + "<tr>";
      html = html + "<td>" + extre.Definition_ + "</td>";
      html = html + "<td>" + extre.GsmNumber + "</td>";
      html = html + "<td>" + extre.Borcu + "</td>";
      html = html + "<td>" + this.ortak.formatMoney(extre.Bakiyesi.toString()) + "</td>";
      html = html + "<td>" + extre.Alacagi + "</td>";
      html = html + "<td>" + extre.Bakiyesi + "</td>";
      html = html + "<td>" + extre.Bakiyesi + "</td>";
      html = html + "<td>" + this.ortak.formatMoney((parseFloat(extre.Bakiyesi.toString()) * parseFloat(extre.Bakiyesi.toString())).toString()) + "</td>";

      html = html + "</tr>";
    });
    html = html + "</tbody></table>";
    html = html + "<table style='width:100%'>";
    html = html + "<tr>";
    html = html + "<td>";
    html = html + "<span style='float:left;width:100%;text-align:right'>Toplam: " + this.ortak.formatMoney(this.toplamalacak.toString()) + " </span>";
    html = html + "</td>";
    html = html + "</tr>";


    html = html + "</table>";
    html = html + "</body></html>";
    

  
  
  }
 
git()
{
  

}
}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/alacakli-cari-hesaplar-report/alacakli-cari-hesaplar-report.ts